import r from "../managers/braze-instance.js";
export function removeAllSubscriptions() {
  r.rr() && r.removeAllSubscriptions();
}